import * as React from 'react';
import { connect } from 'react-redux';
import SurveyDetailsComponent from '../components/surveys/SurveyDetailsComponent';
import SurveyModuleComponent from '../components/surveys/SurveyModuleComponent'
import { Grid, Typography, Button, IconButton } from '@material-ui/core';
import { SurveyWrapper } from '../styles/survey';
import SurveyModuleCountryComponent from '../components/surveys/SurveyModuleCountryComponent';
import { countryRegionListBySurveyId } from 'src/actions/action.common';
import { modeuleListBySurveyId } from 'src/actions/action.module';
import { saveSurvey, editSurvey, setSaveSurveyStatus, publishSurvey, updateSurveyDate, unmountAddEditSurvey, getQuestionStatus, resetQuestionStatus } from 'src/actions/action.survey';
import { getCurrentUrl } from 'src/effects/utils/common';
import { push } from 'connected-react-router';
import { ApplicationMain } from 'src/styles/common';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LoaderComponent from 'src/components/common/loader.component';
import { ModuleEnum } from 'src/constants/Enum/ModuleEnum';
import { ShowError } from '../effects/utils/tostar';
import ConfirmationComponentimport from '../components/common/notification/ConfirmationComponent';
import { SURVEY_APPROVED_QUESTION_CONFIRAMATION } from '../constants/NotificationMessageConstant';

class AddEditSurveyContainer extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            surveyId: 0,
            models: [],
            countryRegions: [],
            showAssignments: false,
            isConfirmDialogShow: false,
            surveyDetails: {
                BaseSurvey: {
                    title: '',
                    year: null,
                    surveyType: '',
                    description: '',
                    deadlineDate: '',
                    status: null,
                    isSpecificCountriesAssigned: false
                },
                CountryModuleSurveyMapping: {
                    moduleIds: [],
                    countryIds: [],
                    order: 1,
                    status: 1,
                    percentageComplete: 1,
                    currentPage: 1,
                    activeTracking: 1
                }
            },
            surveyValidation: {
                isTitleValid: false,
                isYearValid: false,
                isSurveyTypeValid: false,
                isDescriptionValid: false,
                isDdeadlineDateValid: false,
                isDdeadlineMinDateValid: false,
            }
        }

        this.GotoAssignment = this.GotoAssignment.bind(this);
        this.handleSurveyDetailsChange = this.handleSurveyDetailsChange.bind(this);
        this.AssignUnassignCountry = this.AssignUnassignCountry.bind(this);
        this.AssignUnassignModel = this.AssignUnassignModel.bind(this);
        this.SaveAsDraft = this.SaveAsDraft.bind(this);
        this.SaveAsDraft = this.SaveAsDraft.bind(this);
        this.PublishSurvey = this.PublishSurvey.bind(this);
        this.UpdateSurveyState = this.UpdateSurveyState.bind(this);
        this.GoToListing = this.GoToListing.bind(this);
        this.updateSurveyEndDate = this.updateSurveyEndDate.bind(this);
        this.validateDate = this.validateDate.bind(this);
    }

    componentDidMount() {
        getCurrentUrl().then((currUrl: any) => {
            const splitUrl = currUrl.split("/");
            const surveyId = parseInt(splitUrl[splitUrl.length - 1], 10);

            this.setState({
                surveyId
            })

            if (surveyId > 0) {
                this.props.editSurvey(surveyId);
            }

            this.props.modeuleListBySurveyId(surveyId);
            this.props.countryRegionList(surveyId);
        });
    }

    GotoAssignment(showAssignments: any) {
        const status = this.state.surveyDetails.BaseSurvey.status
        if (showAssignments && status !== 2 && status !== 3) {
            const isValid = this.updateValidation();

            if (isValid) {
                const moduleIds = this.state.models.filter((model: any) => model.isChecked === true).map((question: any) => question.id);
                this.props.getQuestionStatus(moduleIds);
            }
        } else {
            this.setState({
                showAssignments
            })
        }
    }

    updateValidation() {
        const baseSurvey = this.state.surveyDetails.BaseSurvey;
        const surveyValidation = this.state.surveyValidation;
        surveyValidation.isTitleValid = baseSurvey.title ? false : true;
        surveyValidation.isYearValid = baseSurvey.year ? false : true;
        surveyValidation.isSurveyTypeValid = baseSurvey.surveyType ? false : true;
        surveyValidation.isDescriptionValid = baseSurvey.description ? false : true;
        surveyValidation.isDdeadlineDateValid = baseSurvey.deadlineDate ? false : true;
        surveyValidation.isDdeadlineMinDateValid = this.validateDate(baseSurvey);
        this.setState({ surveyValidation });

        return !(surveyValidation.surveyValidation || surveyValidation.isYearValid || surveyValidation.isSurveyTypeValid || surveyValidation.isDescriptionValid || surveyValidation.isDdeadlineDateValid);
    }

    handleSurveyDetailsChange = (data: any) => {
        const surveyDetails: any = this.state.surveyDetails;
        surveyDetails.BaseSurvey = data;
        this.setState({ surveyDetails });
        this.updateValidation()
    }

    AssignUnassignCountry(selectedCountries: any, CalledFromOnchange: any) {
        const countryRegions = this.state.countryRegions;
        if (countryRegions && countryRegions.length > 0) {
            countryRegions.forEach((region: any) => {
                region.countries.forEach((country: any) => {
                    if (CalledFromOnchange) {
                        if (parseInt(CalledFromOnchange.id, 10) === country.id) {
                            country.isChecked = CalledFromOnchange.isChecked;
                        }
                    }
                    else {
                        country.isChecked = true;
                        if (selectedCountries.length > 0) {
                            const isPresent = selectedCountries.filter((item: any) => (item === country.id));
                            if (isPresent.length === 0) {
                                country.isChecked = !country.isChecked;
                            }
                        }
                    }
                });

            });
            this.setState({ countryRegions }, () => { this.setState({ countryRegions }) });
        }
    }

    AssignUnassignModel(selectedModels: any, CalledFromOnchange: any) {
        const models = this.state.models;
        const surveyDetails: any = this.state.surveyDetails;
        if (models.length > 0) {
            models.forEach((model: any) => {
                if (CalledFromOnchange) {
                    if (parseInt(CalledFromOnchange.id, 10) === model.id) {
                        model.isChecked = !CalledFromOnchange.isChecked;
                        if (model.isChecked === true) {
                            if (surveyDetails.CountryModuleSurveyMapping.moduleIds.indexOf(model.id) === -1) {
                                surveyDetails.CountryModuleSurveyMapping.moduleIds.push(model.id)
                            }
                        } else {
                            const modelIdIndex = surveyDetails.CountryModuleSurveyMapping.moduleIds.indexOf(model.id)
                            if (modelIdIndex !== -1) {
                                surveyDetails.CountryModuleSurveyMapping.moduleIds.splice(modelIdIndex, 1)
                            }
                        }
                    }
                }
                else {
                    model.isChecked = model.id === ModuleEnum.IntroToDataCollection
                    if (selectedModels.length > 0) {
                        const isPresent = selectedModels.filter((item: any) => (item === model.id));
                        if (isPresent.length > 0) {
                            model.isChecked = !model.isChecked;
                        }
                    }
                }
            });

            this.setState({ models }, () => { this.setState({ models }) });
        }
    }

    UpdateSurveyState(surveyStaus: any) {
        const surveyDetails: any = this.state.surveyDetails;
        const models = this.state.models;
        const moduleIds: any = []
        const countryRegions = this.state.countryRegions;
        const countryIds: any = [];
        if (countryRegions) {
            countryRegions.forEach((region: any) => {
                region.countries.forEach((country: any) => {
                    if (country.isChecked === true) {
                        countryIds.push(country.id);
                    }
                });
            });

            if (countryIds.length === 0 && surveyStaus !== null) {
                ShowError('There should be atleast one country assigned to survey')
                return
            }

            surveyDetails.CountryModuleSurveyMapping.countryIds = countryIds;
        }

        if (models) {
            models.forEach((model: any) => {
                if (model.isChecked === true) {
                    moduleIds.push(model.id);
                }
            });

            surveyDetails.CountryModuleSurveyMapping.moduleIds = moduleIds

        }

        surveyDetails.BaseSurvey.id = this.state.surveyId;
        surveyDetails.BaseSurvey.status = surveyStaus;

        if (surveyStaus === 1) {
            this.props.saveSurvey(this.state.surveyDetails);
        }
        else if (surveyStaus === 2) {
            this.props.saveSurvey(this.state.surveyDetails);
        }
    }

    SaveAsDraft() {
        this.UpdateSurveyState(1); // 1 for saving survey as draft 
    }

    PublishSurvey() {
        this.UpdateSurveyState(2); // 2 for saving survey as publish 
    }

    updateSurveyEndDate() {
        this.props.updateSurveyDate(this.state.surveyDetails.BaseSurvey);
    }

    validateDate(data: any) {
        const todaysDate = new Date();
        const calenderDate = new Date(data.deadlineDate);

        return todaysDate > calenderDate;
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        let BaseSurvey = nextProps && nextProps.survey && nextProps.survey.baseSurvey;
        let CountryModuleSurveyMapping = nextProps && nextProps.survey && nextProps.survey.countryModuleSurveyMapping;
        let surveyDetails = { BaseSurvey, CountryModuleSurveyMapping }
        const isSurveyExist = nextProps && nextProps.survey && nextProps.survey.isSurveyExist ? nextProps.survey.isSurveyExist : false
        let isSurveyPayloadNull: boolean = false;
        if ((nextProps.survey.payload === null || nextProps.survey.payload === undefined) && Object.entries(this.state.surveyDetails).length > 1 && BaseSurvey === undefined && CountryModuleSurveyMapping === undefined) {
            // this.UpdateSurveyState(null);
            BaseSurvey = this.state.surveyDetails && this.state.surveyDetails.BaseSurvey;
            CountryModuleSurveyMapping = this.state.surveyDetails && this.state.surveyDetails.CountryModuleSurveyMapping;
            surveyDetails = { BaseSurvey, CountryModuleSurveyMapping }
            isSurveyPayloadNull = true;
        }

        if (this.state.surveyId === 0 && !isSurveyExist && !isSurveyPayloadNull) {
            if (nextProps) {
                this.setState({
                    countryRegions: nextProps.countryRegions,
                    models: nextProps.models
                }, () => {
                    this.AssignUnassignModel([], null);
                    this.AssignUnassignCountry([], null);
                });
            }
        }
        else if (nextProps && nextProps.survey && nextProps.survey.countryModuleSurveyMapping) {
            this.setState({
                surveyDetails,
                countryRegions: nextProps.countryRegions,
                models: nextProps.models
            }, () => {
                this.AssignUnassignModel(nextProps.survey.countryModuleSurveyMapping.moduleIds, null);
                this.AssignUnassignCountry(nextProps.survey.countryModuleSurveyMapping.countryIds, null);
            });
        }
        else if (isSurveyPayloadNull) {
            this.setState({
                surveyDetails,
                countryRegions: nextProps.countryRegions,
                models: nextProps.models
            }, () => {
                this.AssignUnassignModel(CountryModuleSurveyMapping.moduleIds, null);
                this.AssignUnassignCountry(CountryModuleSurveyMapping.countryIds, null);
            });
        }

        if (this.props.questionStatus !== null) {
            if (!this.props.questionStatus) {
                this.setState({
                    isConfirmDialogShow: true
                }, () => {
                    this.props.resetQuestionStatus(null);
                });
            } else if (this.props.questionStatus) {
                this.setState({
                    showAssignments: true
                }, () => {
                    this.props.resetQuestionStatus(null);
                });
            }
        }
    }

    GoToListing() {
        this.props.redirectTo("/surveys");
        this.setState(this.state, () => { this.setState(this.state) })
    }

    // if user aggree to publish survey without approving question
    handleDialogSubmit = () => {
        this.setState({
            showAssignments: true,
            isConfirmDialogShow: false
        })
    }

    // if user not aggree then user redirect to survey details screen
    onCloseConfirmation = () => {
        this.setState({
            showAssignments: false,
            isConfirmDialogShow: false
        })
    }

    componentWillUnmount() {
        this.props.unmountAddEditSurvey(null);
    }

    render() {
        return (
            <ApplicationMain>
                <LoaderComponent sending={this.props.show} />
                <ConfirmationComponentimport
                    handleDialogSubmit={this.handleDialogSubmit}
                    message={SURVEY_APPROVED_QUESTION_CONFIRAMATION}
                    onCloseConfirmation={this.onCloseConfirmation}
                    open={this.state.isConfirmDialogShow}
                />
                {
                    this.state.showAssignments ?
                        <SurveyModuleCountryComponent
                            handleSurveyDetailsChange={this.handleSurveyDetailsChange}
                            baseSurvey={this.state.surveyDetails.BaseSurvey}
                            surveyValidation={this.state.surveyValidation}
                            GotoAssignment={this.GotoAssignment}
                            countryRegions={this.state.countryRegions}
                            AssignUnassignCountry={this.AssignUnassignCountry}
                            SaveAsDraft={this.SaveAsDraft}
                            PublishSurvey={this.PublishSurvey}
                        /> :

                        <SurveyWrapper>
                            <div className="pageContainer surveyScreen">
                                <div className="pageHeading">
                                    <Grid container={true} spacing={8}>
                                        <Grid item={true} xs={6}>
                                            <div className="pageHeadingTitle">
                                                <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle">
                                                    {this.state.surveyId ? "Edit " : "New "}     Survey
                                            </Typography>
                                            </div>
                                        </Grid>
                                        <Grid item={true} xs={6}>
                                            <div className="text-right">
                                                <Button type="button" className="btn-blue" variant="outlined" size="medium" onClick={this.GotoAssignment.bind(this, true)}>
                                                    Go to Assignment
                                            </Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>

                                <div className="pageBreadcrumb">
                                    <Grid container={true} spacing={8}>
                                        <Grid item={true} xs={6}>
                                            <div className="pageTitleSection">
                                                <IconButton className="backButton" color="inherit" aria-label="Open drawer" onClick={this.GoToListing}>
                                                    <KeyboardBackspaceIcon />
                                                </IconButton>

                                                <div className="pageBreadcrumb">
                                                    <ul>
                                                        <li className="listItem">
                                                            <a href="javascript:void(0)">Surveys</a>
                                                            <IconButton className="arrowRight" color="inherit" aria-label="Arrow Right">
                                                                <KeyboardArrowRight />
                                                            </IconButton>
                                                        </li>
                                                        <li className="listItem">
                                                            <a href="javascript:void(0)" className="active">
                                                                {this.state.surveyId ? "Edit " : "Create New "}
                                                            Survey</a>
                                                        </li>
                                                    </ul>
                                                </div>

                                            </div>
                                        </Grid>

                                        <Grid item={true} xs={6}>
                                            &nbsp;
                                    </Grid>
                                    </Grid>
                                </div>
                                <div className="pageContent">
                                    <Grid container={true} spacing={24}>
                                        <Grid item={true} xs={12}>
                                            <div className="contentSection">
                                                <SurveyDetailsComponent
                                                    updateSurveyEndDate={this.updateSurveyEndDate}
                                                    handleSurveyDetailsChange={this.handleSurveyDetailsChange}
                                                    baseSurvey={this.state.surveyDetails.BaseSurvey}
                                                    surveyValidation={this.state.surveyValidation}
                                                    roleId={this.props.userId}
                                                />
                                                <SurveyModuleComponent
                                                    AssignUnassignModel={this.AssignUnassignModel}
                                                    models={this.state.models}
                                                />
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </SurveyWrapper>
                }
            </ApplicationMain>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        show: state.common.show,
        status: state.survey.status,
        survey: state.survey.survey,
        models: state.model.models,
        countryRegions: state.common.countryRegions,
        questionStatus: state.survey.questionStatus
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        getQuestionStatus: (data: any) => dispatch(getQuestionStatus(data)),
        editSurvey: (data: any) => dispatch(editSurvey(data)),
        modeuleListBySurveyId: (surveyId: any) => dispatch(modeuleListBySurveyId(surveyId)),
        countryRegionList: (surveyId: any) => dispatch(countryRegionListBySurveyId(surveyId)),
        saveSurvey: (data: any) => dispatch(saveSurvey(data)),
        redirectTo: (path: string) => dispatch(push(path)),
        setSaveSurveyStatus: () => dispatch(setSaveSurveyStatus()),
        publishSurvey: (data: any) => dispatch(publishSurvey(data)),
        updateSurveyDate: (data: any) => dispatch(updateSurveyDate(data)),
        unmountAddEditSurvey: (data: any) => dispatch(unmountAddEditSurvey(data)),
        resetQuestionStatus: (data: any) => dispatch(resetQuestionStatus(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddEditSurveyContainer);


// WEBPACK FOOTER //
// ./src/containers/AddEditSurveyContainer.tsx